<template>
  <transition name="fade" mode="out-in">
    <div class="bg-grey-lightest flex h-screen justify-center items-center">
      <div class="bg-white max-w-sm w-full rounded px-6 pt-6 shadow-lg">
        <h1 class="heading">LOGIN</h1>

        <form v-on:submit.prevent="loginUser()" class="flex flex-col">
          <div>
            <label for="email" class="text-xs text-grey-darkest">Email</label>
            <input v-model="loginDetails.email" type="email" placeholder="j.doe@example.com" />
          </div>

          <div>
            <label for="password" class="text-xs text-grey-darkest">Password</label>
            <input v-model="loginDetails.password" type="password" placeholder="bigSecret" />
          </div>

          <div class="flex justify-between items-center mb-8 mt-4">
            <button :disabled="disableSubmit" type="submit" class="btn btn--xl btn--main">
              Log in
            </button>

            <transition name="fade" mode="out-in">
              <div v-if="error" class="absolute text-red-darker ml-24 py-6">{{ error }}</div>
            </transition>

            <a
              href="#"
              class="opacity-0 text-xs underline-none text-blue-light hover:text-blue-dark"
              >Forgot password?</a
            >
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import loginService from './loginService.js';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      formSubmitted: false,
      error: false,
      loginDetails: {
        email: '',
        password: ''
      }
    };
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' }),
    disableSubmit() {
      if (!this.loginDetails.email || !this.loginDetails.password) {
        return true;
      }

      return this.formSubmitted;
    }
  },
  methods: {
    checkCurrentLogin() {
      if (this.currentUser) {
        this.$router.push(this.$route.query.redirect || '/admin/dashboard');
      }
    },
    loginUser: function() {
      this.error = false;
      this.formSubmitted = true;

      loginService
        .login(this.loginDetails)
        .then(data => this.loginSuccessful(data))
        .catch(err => this.loginFailed(err));
    },
    loginSuccessful(data) {
      if (data.type !== 'success' || !data.token) {
        this.loginFailed();
      }
      // store details in localStorage
      this.$store.dispatch('login', data.token);

      this.$router.push(this.$route.query.redirect || '/admin/dashboard');
    },
    loginFailed(err = {}) {
      this.formSubmitted = false;
      this.error =
        err.message || 'There was a problem with the log in process. Please try again later.';
      this.$store.dispatch('logout');
    }
  },
  created: function() {
    this.checkCurrentLogin();
  }
};
</script>
